import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import phoneParser from '../phoneParser';
/**
 * @param {string | { number: string, country?: string }} options
 * @returns {string}
 */

var phoneInternationalFormatter = function phoneInternationalFormatter(options) {
  /* istanbul ignore next */
  var _ref = typeof options === 'string' ? [options] : [options.number, options.country],
      _ref2 = _slicedToArray(_ref, 2),
      number = _ref2[0],
      country = _ref2[1];

  var pn = phoneParser(number, country);
  /* istanbul ignore next */

  return pn ? pn.formatInternational() : pn;
};

export default phoneInternationalFormatter;